export const zhHK = {
  productEdges: '產品特點',
}
